// extracted by mini-css-extract-plugin
export default {"progress":"Tasks_progress__7jUWY","taskButton":"Tasks_taskButton__92Nn1","taskButtonText":"Tasks_taskButtonText__ZuWQF"};